module.exports = "<p>\n  company-export works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/company-export/company-export.component.html
// module id = 994
// module chunks = 1